module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('website', {
    ref: "website"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "shopify-section index-section"
  }, [_c('div', {
    staticClass: "collection-box",
    attrs: {
      "id": "carousel-1599149564459",
      "data-section-id": "1599149564459",
      "data-section-type": "carousel"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grid carousel slick-initialized slick-slider"
  }, [_c('div', {
    staticClass: "slick-list draggable",
    attrs: {
      "aria-live": "polite"
    }
  }, [_c('div', {
    staticClass: "slick-track",
    staticStyle: {
      "opacity": "1",
      "width": "1254px",
      "transform": "translate3d(0px, 0px, 0px)"
    },
    attrs: {
      "role": "listbox"
    }
  }, [_c('div', {
    staticClass: "p-grid"
  }, [_c('div', {
    staticClass: "collection-grid-item p-col"
  }, [_c('a', {
    staticClass: "collection-grid-item__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        return _vm.viewProductByGroupId(531, 'subGroup')
      }
    }
  }, [_c('img', {
    staticClass: "lazyautosizes lazyloaded",
    attrs: {
      "src": "/static/img/web/Kurta_Sets_540x.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "collection-grid-item__title-wrapper"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "collection-grid-item p-col"
  }, [_c('a', {
    staticClass: "collection-grid-item__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        return _vm.viewProductByGroupId(542, 'subGroup')
      }
    }
  }, [_c('img', {
    staticClass: "lazyautosizes lazyloaded",
    attrs: {
      "src": "/static/img/web/Lehenga_Sets_540x.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "collection-grid-item__title-wrapper"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "collection-grid-item p-col"
  }, [_c('a', {
    staticClass: "collection-grid-item__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        return _vm.viewProductByGroupId(541, 'subGroup')
      }
    }
  }, [_c('img', {
    staticClass: "lazyautosizes lazyloaded",
    attrs: {
      "src": "/static/img/web/Sharara_Sets_540x.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "collection-grid-item__title-wrapper"
  })])])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "shopify-section index-section"
  }, [_c('div', {
    staticClass: "collection-box",
    attrs: {
      "id": "carousel-1599149564459",
      "data-section-id": "1599149564459",
      "data-section-type": "carousel"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "grid carousel slick-initialized slick-slider"
  }, [_c('div', {
    staticClass: "slick-list draggable",
    attrs: {
      "aria-live": "polite"
    }
  }, [_c('div', {
    staticClass: "slick-track",
    staticStyle: {
      "opacity": "1",
      "width": "1254px",
      "transform": "translate3d(0px, 0px, 0px)"
    },
    attrs: {
      "role": "listbox"
    }
  }, [_c('div', {
    staticClass: "p-grid"
  }, [_c('div', {
    staticClass: "collection-grid-item p-col"
  }, [_c('a', {
    staticClass: "collection-grid-item__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        return _vm.viewProductByGroupId(547, 'subGroup')
      }
    }
  }, [_c('img', {
    staticClass: "lazyautosizes lazyloaded",
    attrs: {
      "src": "/static/img/web/dresses_540x.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "collection-grid-item__title-wrapper"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "collection-grid-item p-col"
  }, [_c('a', {
    staticClass: "collection-grid-item__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        return _vm.viewProductByGroupId(546, 'subGroup')
      }
    }
  }, [_c('img', {
    staticClass: "lazyautosizes lazyloaded",
    attrs: {
      "src": "/static/img/web/Jumpsuits_540x.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "collection-grid-item__title-wrapper"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "collection-grid-item p-col"
  }, [_c('a', {
    staticClass: "collection-grid-item__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        return _vm.viewProductByGroupId(538, 'subGroup')
      }
    }
  }, [_c('img', {
    staticClass: "lazyautosizes lazyloaded",
    attrs: {
      "src": "/static/img/web/CO-ORD_SETS_540x.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "collection-grid-item__title-wrapper"
  })])])])])])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "shopify-section index-section"
  }, [_c('div', {
    staticClass: "collection-box",
    attrs: {
      "id": "carousel-1599149564459",
      "data-section-id": "1599149564459",
      "data-section-type": "carousel"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "grid carousel slick-initialized slick-slider"
  }, [_c('div', {
    staticClass: "slick-list draggable",
    attrs: {
      "aria-live": "polite"
    }
  }, [_c('div', {
    staticClass: "slick-track",
    staticStyle: {
      "opacity": "1",
      "width": "1254px",
      "transform": "translate3d(0px, 0px, 0px)"
    },
    attrs: {
      "role": "listbox"
    }
  }, [_c('div', {
    staticClass: "p-grid"
  }, [_c('div', {
    staticClass: "collection-grid-item p-col"
  }, [_c('a', {
    staticClass: "collection-grid-item__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        return _vm.viewProductByGroupId(546, 'subGroup')
      }
    }
  }, [_c('img', {
    staticClass: "lazyautosizes lazyloaded",
    attrs: {
      "src": "/static/img/web/baby_1_540x.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "collection-grid-item__title-wrapper"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "collection-grid-item p-col"
  }, [_c('a', {
    staticClass: "collection-grid-item__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        return _vm.viewProductByGroupId(604, 'group')
      }
    }
  }, [_c('img', {
    staticClass: "lazyautosizes lazyloaded",
    attrs: {
      "src": "/static/img/web/kids_1_540x.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "collection-grid-item__title-wrapper"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "collection-grid-item p-col"
  }, [_c('a', {
    staticClass: "collection-grid-item__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        return _vm.viewProductByGroupId(604, 'group')
      }
    }
  }, [_c('img', {
    staticClass: "lazyautosizes lazyloaded",
    attrs: {
      "src": "/static/img/web/tweens_1_540x.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "collection-grid-item__title-wrapper"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "shopify-section index-section"
  }, [_c('div', {
    staticClass: "collection-box",
    attrs: {
      "id": "carousel-1599149564459",
      "data-section-id": "1599149564459",
      "data-section-type": "carousel"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('Carousel', {
    attrs: {
      "value": _vm.displayItemList,
      "numVisible": 4,
      "numScroll": 1,
      "responsiveOptions": _vm.responsiveOptions,
      "circular": true,
      "autoplayInterval": 3000
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(slotProps) {
        return [_c('div', {
          staticStyle: {
            "border-bottom": "0px solid #c8c8c8"
          }
        }, [_c('div', {
          staticClass: "productList"
        }, [_c('div', {
          staticClass: "grid__item small--one-half medium--one-third large-up--one-quarter"
        }, [_c('div', {
          staticClass: "grid-view-item style1 wow fadeIn"
        }, [_c('div', {
          staticClass: "grid-view_image"
        }, [_c('a', {
          attrs: {
            "href": ""
          }
        }, [_c('img', {
          staticStyle: {
            "height": "400px",
            "width": "100%"
          },
          attrs: {
            "src": slotProps.data.singleImageUrl,
            "alt": slotProps.data.name
          },
          on: {
            "click": function($event) {
              return _vm.viewProductDetailsPage(slotProps.data)
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "grid-view-item__title",
          staticStyle: {
            "margin": "2% 0%"
          }
        }, [_vm._v(_vm._s(slotProps.data.name) + "\n                                  ")]), _vm._v(" "), _c('span', {
          staticClass: "product-price__price"
        }, [_vm._v("Rs." + _vm._s(slotProps.data.salesRate))]), _vm._v(" "), _c('div', {
          staticClass: "product-description"
        }, [_vm._v(_vm._s(slotProps.data.description))])])])])])])]
      }
    }])
  })], 1)])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('footerWebsite', {
    ref: "footerWebsite"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "letter"
  }, [_c('img', {
    staticClass: "letter-image",
    attrs: {
      "src": "/static/img/web/lil1.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header text-center wow fadeIn",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeIn"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("ETHNIC CLOTHING")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "letter"
  }, [_c('img', {
    staticClass: "letter-image",
    attrs: {
      "src": "/static/img/web/new.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header text-center wow fadeIn",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeIn"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("SHOP BY CATEGORY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "letter"
  }, [_c('img', {
    staticClass: "letter-image",
    attrs: {
      "src": "/static/img/web/onthego.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header text-center wow fadeIn",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeIn"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("SHOP BY AGE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header text-center wow fadeIn",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeIn"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("BEST SELLERS")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-315e483e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ecommerce/home.vue
// module id = 2126
// module chunks = 0